const url = {
  // master_store_id: 59, // dev
  master_store_id: 24176, // prod
  home: {
    userLoginBack: '/shoper/infor/about/shoper_login/back',
    storeOpen: '/wooshop/v1/public/back/dredge',
    getSMS: '/xk-member/v2/fore/sms-send',
    getDynamicDetail: '/wooshop/v1/dynamic',
    getDynamicList: '/wooshop/v1/dynamic',
    getGoodsDetail: '/xk-products/v1/products/fore/get_product',
    getGoodsDetail: '/xk-products/v1/products/fore/get_product',
    getPublicInfoByStoreId: '/wooshop/v1/public/fore/get_info',
    getHomeInfoByStoreId5: '/wooshop/v1/public/fore/home_all_in_one_5',
    getInfo: '/wooshop/v1/miniapps/fore/foot_print_items_local_platform_2',
    getInfoYc: '/wooshop/v1/miniapps/fore/foot_print_items_local_platform_2_for_yc',
    getInfoYcByCat: '/wooshop/v1/miniapps/fore/foot_print_items_local_platform_2_for_yc_by_cat'
  }
};
export default url; 



// WEBPACK FOOTER //
// ./src/api/interface.js